import React, { useCallback, useMemo } from "react";
import { LiaEditSolid } from "react-icons/lia";

const Hakkimda = ({ setIsOpen, setModalType, user }) => {
  const handleEditClick = useCallback(() => {
    setModalType("Hakkımda");
    setIsOpen(true);
  }, [setModalType, setIsOpen]);

  const aboutText = useMemo(() => {
    return user?.about || "Şimdi bir açıklama ekleyin ve profesyonel hikayenizi paylaşın...";
  }, [user?.about]);

  return (
    <div className="detay-container">
      <p className="flex justify-between mt-4">
        <span className="text-dark text-lg tracking-wide font-medium">Hakkımda</span>
        <span
          className="text-grayy"
          onClick={handleEditClick}
        >
          <LiaEditSolid className="size-[24px]" />
        </span>
      </p>
      <p className="text-grayy text-sm pt-4 min-h-[150px]">
        {aboutText}
      </p>
    </div>
  );
};

export default React.memo(Hakkimda);